import React from 'react';

import { expVal } from '@confluence/feature-experiments';
import { SPACE_SETTINGS_LANDING_PAGE } from '@confluence/named-routes/entry-points/routes.ts';
import { LoadablePaint } from '@confluence/loadable';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

const LazySpaceLegacyContentRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LegacyContentRouteComponent" */
				'./SpaceLegacyContentRouteComponent.tsx'
			)
		).SpaceLegacyContentRouteComponent,
});

export const LazySpaceLegacyContentRoute = ({ params: { spaceKey } }) => {
	if (!expVal('cc-admin-exp-legacy-content-report', 'isEnabled', false)) {
		return <Redirection name={SPACE_SETTINGS_LANDING_PAGE.name} params={{ spaceKey }} />;
	}

	return <LazySpaceLegacyContentRouteComponent spaceKey={spaceKey} />;
};

LazySpaceLegacyContentRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }, isNav4Enabled) => ({
	Screen: {
		pageState: { spaceKey },
		screenEvent: { name: 'legacyContentScreen' },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
